import CreditLimit, { CreditLimitData } from '@/models/economy/CreditLimit';
import { axios } from '@/plugins/vueaxios'

export default class EconomyService {

  public static getDefaultCreditLimit(): Promise<any> {
    return new Promise((resolve, reject) => {
      axios
        .get('/v4/site/economy/default-credit-limit')
        .then((response) => resolve(response))
        .catch(error => {
          reject(error);
        });
    })
  }
  public static saveDefaultCreditLimit(data: Partial<CreditLimitData>): Promise<any> {
    return axios.post('/v4/site/economy/default-credit-limit', data);
  }

}